import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getCatalogClues = async ({ commit }, search = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/clues/catalog?search=${encodeURIComponent(search)}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogClues = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/clues/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getFederalEntitiesForClues = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/federal-entities/dropdown`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
